<div class="home">

  <div #header id="navContainer" class="row sticky nav-container">
    <div class="col-12 p-0">
      <app-edtell-header edtell-header></app-edtell-header>
    </div>
  </div>

  <mat-toolbar class="container breadcrumbs-container m-auto" *ngIf="hasBreadcrumbs">
    <div class="navbar-nav w-100 h-100">
      <div class="row h-100">
        <div [ngClass]="['col-9', 'd-flex', 'align-items-center', 'h-100']">
          <app-breadcrumb-navigation></app-breadcrumb-navigation>
        </div>
        <div class="col-3 pt-1 d-inline-flex justify-center align-items-center">
          <app-search-bar></app-search-bar>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <!-- Content -->
  <div class="body container">
    <main>
      <!-- With sidebar -->
      <div id="wrapper" class="row h-100">

        <div class="col-lg-2 col-md-3 col-12 sidebar-nav" *ngIf="sidebarConfig != null">
          <app-dynamic-sidebar [config]="sidebarConfig"></app-dynamic-sidebar>
        </div>

        <div id="page-content-wrapper" class="col">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>

  </div>

  <app-edtell-footer></app-edtell-footer>
</div>
